<template>
  <b-form-group
    label="Tema"
    label-for="id_qrcode_colors"
  >
    <validation-provider
      #default="{ errors }"
      name="Tema"
      rules="required"
    >
      <v-select
        id="id_qrcode_colors"
        v-model="dataItem.id_qrcode_colors"
        label="title"
        :options="dataList"
        :reduce="item => item.id"
        placeholder="Tema"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'QrCodeColors',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
      locale: 'tr',
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['qrcodes/dataItem']
    },
    dataList() {
      return this.$store.getters['qrcodeColors/dataList']
    },
  },
  created() {
    localize(this.locale)
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('qrcodeColors/getDataList')
        .then(response => {
          if (response) {
            if (!this.dataItem.id_qrcode_colors) {
              // eslint-disable-next-line prefer-destructuring
              this.dataItem.id_qrcode_colors = response[0].id
            }
          }
        })
    },
  },
}
</script>
